export default __webpack_public_path__ + "static/media/palin-blue.33107b11.svg";